// extracted by mini-css-extract-plugin
module.exports = {"component":"Info_component__19tek","content":"Info_content__ylI2u"};